module.exports = __webpack_public_path__ + "static/img/logo-iracema-digital.1b81e02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-iracema-digital.png
// module id = 01SX
// module chunks = 1